@if (redeemedCampaign(); as redeemedCampaign) {
  <ngx-particles
    [id]="confettiId"
    [options]="particlesConfettiOptions"
  ></ngx-particles>
  <div class="free-money-redeemed-success-container" *transloco="let t"
       [ngClass]="campaignType() == CampaignType.FREE_MONEY ? 'free-money' : 'loyalty'">
    <div class="amount">{{ redeemedCampaign.campaign.reward | loyaltyCurrency }}</div>
    @if (campaignType() == CampaignType.FREE_MONEY) {
      <div class="details">{{
          t('redeemedCampaignSuccess.message', {
            reward: redeemedCampaign.campaign.reward | loyaltyCurrency,
            transactionAmount: redeemedCampaign.transactionAmount | loyaltyCurrency,
            merchantName: redeemedCampaign.location.name
          })
        }}
      </div>
    } @else if (redeemedCampaign.campaign.additionalConditions?.additionalConditionsType) {
      @switch (redeemedCampaign.campaign.additionalConditions?.additionalConditionsType) {
        @case (AdditionalConditionsType.AMOUNT_SPENT) {
          <div class="details">{{
              t('redeemedCampaignSuccess.amount', {
                reward: redeemedCampaign.campaign.reward | loyaltyCurrency,
                transactionAmount: redeemedCampaign.transactionAmount | loyaltyCurrency,
                merchantName: redeemedCampaign.campaign.merchant?.name
              })
            }}
          </div>
        }
        @case (AdditionalConditionsType.LOYALTY) {
          <div class="details">{{
              t('redeemedCampaignSuccess.loyalty', {
                reward: redeemedCampaign.campaign.reward | loyaltyCurrency,
                merchantName: redeemedCampaign.campaign.merchant?.name
              })
            }}
          </div>
        }
        @case (AdditionalConditionsType.NUMBER_OF_TRANSACTIONS) {
          <div class="details">{{
              t('redeemedCampaignSuccess.purchases', {
                reward: redeemedCampaign.campaign.reward | loyaltyCurrency,
                purchasesCount: redeemedCampaign.campaign.additionalConditions!.value,
                merchantName: redeemedCampaign.campaign.merchant?.name
              })
            }}
          </div>
        }
      }
    }
    <button mat-stroked-button class="button-medium" (click)="navigateToHome()">{{ t('home') }}</button>
    <div class="map-card-container" [class.online]="redeemedCampaign.campaign.online">
      <div class="map-header">
        <img class="merchant-logo"
             ngSrc="{{redeemedCampaign.campaign.merchant?.logoUrl || 'assets/images/brand-default.png'}}"
             alt="brand-logo"
             height="40" width="40">
        <div class="info">
          <div class="merchant-name">{{ redeemedCampaign.campaign.merchant?.name }}</div>
          @if (!redeemedCampaign.campaign.online) {
            <div class="venue-address">{{ locationDisplayString() }}</div>
          }
        </div>
      </div>
      @if (!redeemedCampaign.campaign.online) {
        <div class="map-card">
          <google-map
            class="google-map-card"
            mapId="ddd9498ff818dc08"
            height="200px"
            width="100%"
            [options]="mapOptions"
            [center]="mapCenter()"
            [zoom]="zoom">
            <map-advanced-marker [position]="mapCenter()" [content]="markerContent()"/>
          </google-map>
        </div>
      }
    </div>
  </div>
}
